<div>
  <a odxLink href="#" i18n="@@floorplan.details.showAttachements.btn" (click)="showAttachments(); $event.preventDefault()">
    Sachnummern anzeigen</a
  >
</div>
